export default __webpack_public_path__ + "static/media/odznaka-1.38ea3a0b.svg";